import { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type {
    SpacingSubBlock,
    TechSpecBlock as TechSpecBlockValue,
} from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type ITechSpecProps = Immutable<
    {
        header: string | null | undefined;
        spacing: SpacingSubBlock | null | undefined;
        variant?: "foundation";
    } & (
        | { specsHTML: string; children?: never }
        | { specsHTML?: never; children: React.ReactNode }
    )
>;

const unwrapRichText = (value: string): string => {
    return value.replace(/class=.rich-text./g, "");
};

export const TechSpec = (props: ITechSpecProps): React.JSX.Element => {
    return (
        <div
            className={concatClassNames([
                styles.techSpecBlock,
                props.variant === "foundation"
                    ? styles.techSpecBlockFoundation
                    : null,
                getGlobalSpacingClasses(props.spacing),
            ])}
        >
            <h5 className={styles.techSpecBlockHeader}>{props.header}</h5>
            {props.specsHTML !== undefined ? (
                <div
                    className={styles.techSpecBlockSpecs}
                    dangerouslySetInnerHTML={{ __html: props.specsHTML }}
                ></div>
            ) : (
                <div className={styles.techSpecBlockSpecs}>
                    {props.children}
                </div>
            )}
        </div>
    );
};

export const TechSpecBlock = (
    props: Immutable<{ value: TechSpecBlockValue }>,
): React.JSX.Element => {
    return (
        <TechSpec
            header={props.value.header}
            spacing={props.value.spacing}
            specsHTML={unwrapRichText(props.value.specs ?? "")}
        />
    );
};
